
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as chatwY4IaHdRWaSEoNHPxZFGKYlb_45MJZWuHkoJX4Z4kHsAEMeta } from "/opt/buildhome/repo/pages/chat.vue?macro=true";
import { default as jobs_45JgUSdYDmJFKqL1y3bOMzoUAGdLCXz9WyC6Gn5TAHW4Meta } from "/opt/buildhome/repo/pages/jobs.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as loginvP8ccWpwo4AD2A7JkB0PknqCrPjVD2Gt_iPqML2mXY4Meta } from "/opt/buildhome/repo/modules/auth/pages/login.vue?macro=true";
import { default as logouthAoqybpEHIL0apy88rSNifiy1jDAvIU1QPv3qGKDLw8Meta } from "/opt/buildhome/repo/modules/auth/pages/logout.vue?macro=true";
import { default as signinkKXDgOuGPizXogLJNNMBmsaOPphnsHLJNM4Yux2lhgcMeta } from "/opt/buildhome/repo/modules/auth/pages/signin.vue?macro=true";
import { default as verify0rdvESNy_BzC3t83H3ZZ19LgZeD1gP4XsoQPtbqXHbgMeta } from "/opt/buildhome/repo/modules/auth/pages/verify.vue?macro=true";
import { default as pwa_45demoR_45X7uxghQLOkyY7uYk_452zrau0w8rA2UVKasbb0on2JcMeta } from "/opt/buildhome/repo/pages/pwa-demo.vue?macro=true";
import { default as pwa_45test6Ms6l40c6Z9ZyODDspLe87m3nwKJZhMgwCXIiY_45vZZQMeta } from "/opt/buildhome/repo/pages/pwa-test.vue?macro=true";
import { default as redirect5btvWZyW4ecydNcenQasRcN6R726sD0_YiMk3pKd7OIMeta } from "/opt/buildhome/repo/modules/auth/pages/redirect.vue?macro=true";
import { default as registerwziz0e4eb65QQBs0iNwu29ROkY11LCeNBWfNhMvz8qsMeta } from "/opt/buildhome/repo/modules/auth/pages/register.vue?macro=true";
import { default as requestsG_7WZ9g6t8XbTO4fSgksp2yU0Ur31FeYs5Rmbfal_45CIMeta } from "/opt/buildhome/repo/pages/requests.vue?macro=true";
import { default as showcaseXnmkYvWZfIDWqZl5Y6U8S0R3BCmAWtlka_45pAeXZgYAsMeta } from "/opt/buildhome/repo/pages/showcase.vue?macro=true";
import { default as test_45pwa20DIxBFPBDpSO6PWPcp7CWigNqkKdEAb7NacswPVY8YMeta } from "/opt/buildhome/repo/pages/test-pwa.vue?macro=true";
import { default as contact_45usL5sA0Zp5dgV4Bd8KjQI9Pm2HbGOBREFE542cDiDC_P8Meta } from "/opt/buildhome/repo/pages/contact-us.vue?macro=true";
import { default as faqJzhwHKNKAc_l5eQ2QUqAlN15u1Bb48HOmgmbKZI3oSkMeta } from "/opt/buildhome/repo/pages/account/faq.vue?macro=true";
import { default as recent_45jobskMXRojCGOkQMRoOeg3YrDIcj7jMHqpiltVEW0Km0GoEMeta } from "/opt/buildhome/repo/pages/recent-jobs.vue?macro=true";
import { default as indexjYLHr6NXjpvFf_gXujeNDoOTZnxcSaS9oAuKnKWOqgoMeta } from "/opt/buildhome/repo/pages/search/index.vue?macro=true";
import { default as subscriptionGFHy__asELmtoFmzVzbR9CGsUQZ8YhzDoFH4b7qgDAwMeta } from "/opt/buildhome/repo/modules/subscription/pages/subscription.vue?macro=true";
import { default as terms_45of_45useoGLcwREWluCopSyrI_45CbbyannPtxLs2O1AKaKaL0EDgMeta } from "/opt/buildhome/repo/pages/terms-of-use.vue?macro=true";
import { default as aboutN0gVZWZ2bu6LMLPfgWEUOAlyCgOUoksX2EFF4sdCoWgMeta } from "/opt/buildhome/repo/pages/account/about.vue?macro=true";
import { default as indexNTJSwtEujotd0krVwSSpZwgUZag_I1m4U4xoWPDEMogMeta } from "/opt/buildhome/repo/modules/auth/pages/account/index.vue?macro=true";
import { default as createJobFormGk3jqzlY_xQZfz2IIp_45FpgXMSU83_45NKdNV4m4DAk0xQMeta } from "/opt/buildhome/repo/pages/createJobForm.vue?macro=true";
import { default as notifications9S3bHYysej2k8kpvBHFH7hztJhjtdydDRbw345gLuUcMeta } from "/opt/buildhome/repo/pages/notifications.vue?macro=true";
import { default as indexEPbLo_Qh0clYxIBSQdejsZVGgBicXvTo4awouhofpuAMeta } from "/opt/buildhome/repo/pages/profile/index.vue?macro=true";
import { default as codeof_45conductJJ78ru3_Ny00ysoIZEDzHg9nCTcCrHt8SKX_45ZLLiRKkMeta } from "/opt/buildhome/repo/pages/codeof-conduct.vue?macro=true";
import { default as privacy_45policyek63hKQ8ZMx2nIQV88L2_dad1Zv4m5Ym_n4RQ7NuSXAMeta } from "/opt/buildhome/repo/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordeNEUToz5WwBye48inOHdFXqf2eurjD3rwj5ix_45Z1OFwMeta } from "/opt/buildhome/repo/modules/auth/pages/reset-password.vue?macro=true";
import { default as indexabo5mS5VOKSSlMZk_yBB0Y1oPajEMqFKoMlE1hYwNlIMeta } from "/opt/buildhome/repo/pages/addresses/index.vue?macro=true";
import { default as manageCthK1YOoaQISW4sUJE3Nb7Gnt5wca72GfFqI53r9Ke4Meta } from "/opt/buildhome/repo/pages/addresses/manage.vue?macro=true";
import { default as indexq5Bl4LIHTcbXmPNS0fKXDelEn6LAep_45mY11K2XhuTMcMeta } from "/opt/buildhome/repo/modules/auth/pages/onboarding/index.vue?macro=true";
import { default as recommended_45jobsuHGWdgXHK1ELBKnqVF4FVGEWutDPy_LSZZQrmjqyOp8Meta } from "/opt/buildhome/repo/pages/recommended-jobs.vue?macro=true";
import { default as _91id_93ndJx3DTZBGdkIdC8qerf9jlzQb54k0q_45lcf09lQyS0gMeta } from "/opt/buildhome/repo/pages/userDetails/[id].vue?macro=true";
import { default as my_45ordersvfWyBpCpnaqqlTPnjPt7LANzd81w0BFA1CkZhF_450zvIMeta } from "/opt/buildhome/repo/pages/account/my-orders.vue?macro=true";
import { default as appliedWorkerListb1DK7CaB0rfVvVsi0SNuH83U0NEr7AhzgWwfwawxIE8Meta } from "/opt/buildhome/repo/pages/appliedWorkerList.vue?macro=true";
import { default as welcomehHNnkiYIUpcBsVAO8rsnfDC6ASmfrTq6kchAdesJVmIMeta } from "/opt/buildhome/repo/modules/auth/pages/onboarding/welcome.vue?macro=true";
import { default as prohibited_45contentBVTzHmSCuSuz3EU4BtyLQqVAV6M3hE5LduUuq_dTxIIMeta } from "/opt/buildhome/repo/pages/prohibited-content.vue?macro=true";
import { default as help_45centret8HaAtIqsc_45LipFnD_ShrHeBvYXk22ljm2sw_gZDCSsMeta } from "/opt/buildhome/repo/pages/account/help-centre.vue?macro=true";
import { default as disclaimer_87zYb11GTYLtZdXEJMssVRFZ_45k7pAJd22_45hZKcEYwYMeta } from "/opt/buildhome/repo/modules/auth/pages/onboarding/disclaimer.vue?macro=true";
import { default as index_V2Zzr_obNnXWF0qURxtKvrzoaiuwUuRtwlF5pU_4SsMeta } from "/opt/buildhome/repo/modules/auth/pages/account/settings/index.vue?macro=true";
import { default as id_45selector_9iYxH8FlJ8DihVZ7Y_I_45uQ0Cgx5N259ZTBxsKWGZ7sMeta } from "/opt/buildhome/repo/modules/auth/pages/onboarding/id-selector.vue?macro=true";
import { default as frankieone_45verificationwv0LpvtDURMe4zFNPYJjWXN2mP9_Qdqxs03L3t4ZKCAMeta } from "/opt/buildhome/repo/pages/frankieone-verification.vue?macro=true";
import { default as _91clientSlug_93hUcg7liq8yVpobGv_m0SJ_na2mj3lIH21s3Onwi_45QPYMeta } from "/opt/buildhome/repo/modules/auth/pages/onboarding/[clientSlug].vue?macro=true";
import { default as personal_45detailsDv30cp2IrrQkDSCgPOXwmKXM8ZeJ2uoQIHeKja_5fVIMeta } from "/opt/buildhome/repo/modules/auth/pages/account/personal-details.vue?macro=true";
import { default as _91id_93ziwWXFi66gQStVNz5ARz4SKJh5bhlLqeSf_45Lla9qSQEMeta } from "/opt/buildhome/repo/pages/search/support-workers/[id].vue?macro=true";
import { default as indexoFEskQ1os4cwaS18QzidherYavNoUZwJk_45yGXfrkMusMeta } from "/opt/buildhome/repo/pages/profile/services-offered/index.vue?macro=true";
import { default as delete_45account8kvJ0JlzoCLo2wlxjnrJP9t7e1Tb_45S5COedJLCcamkgMeta } from "/opt/buildhome/repo/modules/auth/pages/account/settings/delete-account.vue?macro=true";
import { default as forget_45passwordkCXpfTRJVMR_45gTSbIoa5rPPyvlW36nVmVyOB0LdNOqQMeta } from "/opt/buildhome/repo/modules/auth/pages/account/settings/forget-password.vue?macro=true";
import { default as update_45passwordfwLtBvAHBSYExSdIXl_IrkP0JfKIVojiWFBBYPkyxq0Meta } from "/opt/buildhome/repo/modules/auth/pages/account/settings/update-password.vue?macro=true";
import { default as index6zpZOevLGq18s_HeDQ82shf50AC8u_455Is7253wAr_45gkMeta } from "/opt/buildhome/repo/pages/profile/profile-information/index.vue?macro=true";
import { default as indexw_45rqwfftumbipSI5kw3msffxL5jt1CWBKbYB1rmH000Meta } from "/opt/buildhome/repo/pages/profile/support-requirements/index.vue?macro=true";
import { default as update_45email_45addressTYuHgQ6jGhKkz_IgvfsfpjcL833eo3VJM_YVPNBFcCgMeta } from "/opt/buildhome/repo/modules/auth/pages/account/settings/update-email-address.vue?macro=true";
import { default as educationnxDXzxwkZZTQqMtVJyzXN_JQDyw69EId1uez50esuKkMeta } from "/opt/buildhome/repo/pages/profile/profile-information/education.vue?macro=true";
import { default as availabilitiesYBAzuxcVJbkQAelst_45jrMXnPP67b4apIF0o_ybjjQFEMeta } from "/opt/buildhome/repo/pages/profile/services-offered/availabilities.vue?macro=true";
import { default as your_45profilesF6T659l2rqhS5kWTlnHai3W2EkuiDL5kvYwNq3_451fYMeta } from "/opt/buildhome/repo/pages/profile/profile-information/your-profile.vue?macro=true";
import { default as indicative_45ratesAfJkrBkK9bEH5XXUuC2uuhEe8prSzztuRpqhlXs2EOYMeta } from "/opt/buildhome/repo/pages/profile/services-offered/indicative-rates.vue?macro=true";
import { default as service_45offeringszfYKwK55RsqTuCLAN_45QLprqsLDMz5tYdLel7eAdZYTEMeta } from "/opt/buildhome/repo/pages/profile/services-offered/service-offerings.vue?macro=true";
import { default as work_45experienceXB5CQsfuI4LSP4ORuACsjU629V_450nNq7X1jyZj369v4Meta } from "/opt/buildhome/repo/pages/profile/profile-information/work-experience.vue?macro=true";
import { default as personal_45detailsV88gwBeE8UVD1bLu4EySJHTIWr5iLuGkq3CYHIBDdJ0Meta } from "/opt/buildhome/repo/pages/profile/profile-information/personal-details.vue?macro=true";
import { default as identity_45documents6N_45SSTOeRJoOxUTybPu3cVoYsTttqWPZMmwhJbi9HS0Meta } from "/opt/buildhome/repo/pages/profile/profile-information/identity-documents.vue?macro=true";
import { default as required_45work_45hours411nD705EqlWrBeJrrjtJBnyJHIAyhGUV5o7v0ClIRwMeta } from "/opt/buildhome/repo/pages/profile/support-requirements/required-work-hours.vue?macro=true";
import { default as support_45preferences7Noz_45w6SkG3rHgcoL6bjcmjvUdQbbA7Pdl86F6WtD74Meta } from "/opt/buildhome/repo/pages/profile/support-requirements/support-preferences.vue?macro=true";
import { default as support_45requirements010p5NhGSChE_45mDWVQQGsVXmXu6FNoKrsGM7wQ8C46IMeta } from "/opt/buildhome/repo/pages/profile/support-requirements/support-requirements.vue?macro=true";
import { default as qualifications_45neededaBokFuc2JcX3F4T2HA_mJEeMdU_Uq8Fbv1db91tsU8YMeta } from "/opt/buildhome/repo/pages/profile/support-requirements/qualifications-needed.vue?macro=true";
import { default as support_45seeker_45preferences2w4557DLqZVloyThRw887m_pbbu_45oCUOjavASWi00YUMeta } from "/opt/buildhome/repo/pages/profile/services-offered/support-seeker-preferences.vue?macro=true";
import { default as index2nw18EFlRdPnU8HTzR1CvBILvjWJ_45wAXBmLkyiboFY4Meta } from "/opt/buildhome/repo/pages/profile/profile-information/required-documents/index.vue?macro=true";
import { default as training_45and_45qualifications_45LJPSXEcZXkLYsM_b7WCtKxqsUs2xvSZUpwSH374RAAMeta } from "/opt/buildhome/repo/pages/profile/profile-information/training-and-qualifications.vue?macro=true";
import { default as _91document_93NKft53uX0nKUZnJKM3ZAcvE_45evXbn7DVyTpai8ox8aYMeta } from "/opt/buildhome/repo/pages/profile/profile-information/required-documents/[document].vue?macro=true";
export default [
  {
    name: "chat",
    path: "/chat",
    component: () => import("/opt/buildhome/repo/pages/chat.vue")
  },
  {
    name: "jobs",
    path: "/jobs",
    meta: jobs_45JgUSdYDmJFKqL1y3bOMzoUAGdLCXz9WyC6Gn5TAHW4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/jobs.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta || {},
    alias: ["/home"],
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginvP8ccWpwo4AD2A7JkB0PknqCrPjVD2Gt_iPqML2mXY4Meta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/opt/buildhome/repo/modules/auth/pages/logout.vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: signinkKXDgOuGPizXogLJNNMBmsaOPphnsHLJNM4Yux2lhgcMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/signin.vue")
  },
  {
    name: "verify",
    path: "/verify",
    meta: { ...(verify0rdvESNy_BzC3t83H3ZZ19LgZeD1gP4XsoQPtbqXHbgMeta || {}), ...{"middleware":["verify"]} },
    component: () => import("/opt/buildhome/repo/modules/auth/pages/verify.vue")
  },
  {
    name: "pwa-demo",
    path: "/pwa-demo",
    component: () => import("/opt/buildhome/repo/pages/pwa-demo.vue")
  },
  {
    name: "pwa-test",
    path: "/pwa-test",
    component: () => import("/opt/buildhome/repo/pages/pwa-test.vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    meta: redirect5btvWZyW4ecydNcenQasRcN6R726sD0_YiMk3pKd7OIMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/redirect.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerwziz0e4eb65QQBs0iNwu29ROkY11LCeNBWfNhMvz8qsMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/register.vue")
  },
  {
    name: "requests",
    path: "/requests",
    meta: requestsG_7WZ9g6t8XbTO4fSgksp2yU0Ur31FeYs5Rmbfal_45CIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/requests.vue")
  },
  {
    name: "showcase",
    path: "/showcase",
    component: () => import("/opt/buildhome/repo/pages/showcase.vue")
  },
  {
    name: "test-pwa",
    path: "/test-pwa",
    component: () => import("/opt/buildhome/repo/pages/test-pwa.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    meta: contact_45usL5sA0Zp5dgV4Bd8KjQI9Pm2HbGOBREFE542cDiDC_P8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/contact-us.vue")
  },
  {
    name: "account-faq",
    path: "/account/faq",
    meta: faqJzhwHKNKAc_l5eQ2QUqAlN15u1Bb48HOmgmbKZI3oSkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/faq.vue")
  },
  {
    name: "recent-jobs",
    path: "/recent-jobs",
    component: () => import("/opt/buildhome/repo/pages/recent-jobs.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexjYLHr6NXjpvFf_gXujeNDoOTZnxcSaS9oAuKnKWOqgoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/search/index.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: { ...(subscriptionGFHy__asELmtoFmzVzbR9CGsUQZ8YhzDoFH4b7qgDAwMeta || {}), ...{"middleware":["worker"]} },
    alias: ["/my-profile/subscribe"],
    component: () => import("/opt/buildhome/repo/modules/subscription/pages/subscription.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    meta: terms_45of_45useoGLcwREWluCopSyrI_45CbbyannPtxLs2O1AKaKaL0EDgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/terms-of-use.vue")
  },
  {
    name: "account-about",
    path: "/account/about",
    meta: aboutN0gVZWZ2bu6LMLPfgWEUOAlyCgOUoksX2EFF4sdCoWgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/about.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: indexNTJSwtEujotd0krVwSSpZwgUZag_I1m4U4xoWPDEMogMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/account/index.vue")
  },
  {
    name: "createJobForm",
    path: "/createJobForm",
    meta: createJobFormGk3jqzlY_xQZfz2IIp_45FpgXMSU83_45NKdNV4m4DAk0xQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/createJobForm.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notifications9S3bHYysej2k8kpvBHFH7hztJhjtdydDRbw345gLuUcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexEPbLo_Qh0clYxIBSQdejsZVGgBicXvTo4awouhofpuAMeta || {},
    alias: ["/my-profile"],
    component: () => import("/opt/buildhome/repo/pages/profile/index.vue")
  },
  {
    name: "codeof-conduct",
    path: "/codeof-conduct",
    meta: codeof_45conductJJ78ru3_Ny00ysoIZEDzHg9nCTcCrHt8SKX_45ZLLiRKkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/codeof-conduct.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyek63hKQ8ZMx2nIQV88L2_dad1Zv4m5Ym_n4RQ7NuSXAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/privacy-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordeNEUToz5WwBye48inOHdFXqf2eurjD3rwj5ix_45Z1OFwMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/reset-password.vue")
  },
  {
    name: "addresses",
    path: "/addresses",
    meta: indexabo5mS5VOKSSlMZk_yBB0Y1oPajEMqFKoMlE1hYwNlIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/addresses/index.vue")
  },
  {
    name: "addresses-manage",
    path: "/addresses/manage",
    component: () => import("/opt/buildhome/repo/pages/addresses/manage.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: indexq5Bl4LIHTcbXmPNS0fKXDelEn6LAep_45mY11K2XhuTMcMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/onboarding/index.vue")
  },
  {
    name: "recommended-jobs",
    path: "/recommended-jobs",
    component: () => import("/opt/buildhome/repo/pages/recommended-jobs.vue")
  },
  {
    name: "userDetails-id",
    path: "/userDetails/:id()",
    meta: _91id_93ndJx3DTZBGdkIdC8qerf9jlzQb54k0q_45lcf09lQyS0gMeta || {},
    component: () => import("/opt/buildhome/repo/pages/userDetails/[id].vue")
  },
  {
    name: "account-my-orders",
    path: "/account/my-orders",
    meta: my_45ordersvfWyBpCpnaqqlTPnjPt7LANzd81w0BFA1CkZhF_450zvIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/my-orders.vue")
  },
  {
    name: "appliedWorkerList",
    path: "/appliedWorkerList",
    meta: appliedWorkerListb1DK7CaB0rfVvVsi0SNuH83U0NEr7AhzgWwfwawxIE8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/appliedWorkerList.vue")
  },
  {
    name: "onboarding-welcome",
    path: "/onboarding/welcome",
    meta: welcomehHNnkiYIUpcBsVAO8rsnfDC6ASmfrTq6kchAdesJVmIMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/onboarding/welcome.vue")
  },
  {
    name: "prohibited-content",
    path: "/prohibited-content",
    meta: prohibited_45contentBVTzHmSCuSuz3EU4BtyLQqVAV6M3hE5LduUuq_dTxIIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/prohibited-content.vue")
  },
  {
    name: "account-help-centre",
    path: "/account/help-centre",
    meta: help_45centret8HaAtIqsc_45LipFnD_ShrHeBvYXk22ljm2sw_gZDCSsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/help-centre.vue")
  },
  {
    name: "onboarding-disclaimer",
    path: "/onboarding/disclaimer",
    meta: disclaimer_87zYb11GTYLtZdXEJMssVRFZ_45k7pAJd22_45hZKcEYwYMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/onboarding/disclaimer.vue")
  },
  {
    name: "account-settings",
    path: "/account/settings",
    meta: index_V2Zzr_obNnXWF0qURxtKvrzoaiuwUuRtwlF5pU_4SsMeta || {},
    alias: ["/my-profile/account-settings"],
    component: () => import("/opt/buildhome/repo/modules/auth/pages/account/settings/index.vue")
  },
  {
    name: "onboarding-id-selector",
    path: "/onboarding/id-selector",
    meta: id_45selector_9iYxH8FlJ8DihVZ7Y_I_45uQ0Cgx5N259ZTBxsKWGZ7sMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/onboarding/id-selector.vue")
  },
  {
    name: "frankieone-verification",
    path: "/frankieone-verification",
    meta: frankieone_45verificationwv0LpvtDURMe4zFNPYJjWXN2mP9_Qdqxs03L3t4ZKCAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/frankieone-verification.vue")
  },
  {
    name: "onboarding-clientSlug",
    path: "/onboarding/:clientSlug()",
    meta: _91clientSlug_93hUcg7liq8yVpobGv_m0SJ_na2mj3lIH21s3Onwi_45QPYMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/onboarding/[clientSlug].vue")
  },
  {
    name: "account-personal-details",
    path: "/account/personal-details",
    meta: personal_45detailsDv30cp2IrrQkDSCgPOXwmKXM8ZeJ2uoQIHeKja_5fVIMeta || {},
    component: () => import("/opt/buildhome/repo/modules/auth/pages/account/personal-details.vue")
  },
  {
    name: "search-support-workers-id",
    path: "/search/support-workers/:id()",
    meta: _91id_93ziwWXFi66gQStVNz5ARz4SKJh5bhlLqeSf_45Lla9qSQEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/search/support-workers/[id].vue")
  },
  {
    name: "profile-services-offered",
    path: "/profile/services-offered",
    meta: indexoFEskQ1os4cwaS18QzidherYavNoUZwJk_45yGXfrkMusMeta || {},
    alias: ["/my-profile/services"],
    component: () => import("/opt/buildhome/repo/pages/profile/services-offered/index.vue")
  },
  {
    name: "account-settings-delete-account",
    path: "/account/settings/delete-account",
    meta: delete_45account8kvJ0JlzoCLo2wlxjnrJP9t7e1Tb_45S5COedJLCcamkgMeta || {},
    alias: ["/my-profile/account-settings/delete-account"],
    component: () => import("/opt/buildhome/repo/modules/auth/pages/account/settings/delete-account.vue")
  },
  {
    name: "account-settings-forget-password",
    path: "/account/settings/forget-password",
    meta: forget_45passwordkCXpfTRJVMR_45gTSbIoa5rPPyvlW36nVmVyOB0LdNOqQMeta || {},
    alias: ["/my-profile/account-settings/forget-password"],
    component: () => import("/opt/buildhome/repo/modules/auth/pages/account/settings/forget-password.vue")
  },
  {
    name: "account-settings-update-password",
    path: "/account/settings/update-password",
    meta: update_45passwordfwLtBvAHBSYExSdIXl_IrkP0JfKIVojiWFBBYPkyxq0Meta || {},
    alias: ["/my-profile/account-settings/update-password"],
    component: () => import("/opt/buildhome/repo/modules/auth/pages/account/settings/update-password.vue")
  },
  {
    name: "profile-profile-information",
    path: "/profile/profile-information",
    meta: index6zpZOevLGq18s_HeDQ82shf50AC8u_455Is7253wAr_45gkMeta || {},
    alias: ["/my-profile/profile-info"],
    component: () => import("/opt/buildhome/repo/pages/profile/profile-information/index.vue")
  },
  {
    name: "profile-support-requirements",
    path: "/profile/support-requirements",
    meta: indexw_45rqwfftumbipSI5kw3msffxL5jt1CWBKbYB1rmH000Meta || {},
    alias: ["/my-profile/support-reqs"],
    component: () => import("/opt/buildhome/repo/pages/profile/support-requirements/index.vue")
  },
  {
    name: "account-settings-update-email-address",
    path: "/account/settings/update-email-address",
    meta: update_45email_45addressTYuHgQ6jGhKkz_IgvfsfpjcL833eo3VJM_YVPNBFcCgMeta || {},
    alias: ["/my-profile/account-settings/update-email-address"],
    component: () => import("/opt/buildhome/repo/modules/auth/pages/account/settings/update-email-address.vue")
  },
  {
    name: "profile-profile-information-education",
    path: "/profile/profile-information/education",
    meta: educationnxDXzxwkZZTQqMtVJyzXN_JQDyw69EId1uez50esuKkMeta || {},
    alias: ["/my-profile/profile-info/education"],
    component: () => import("/opt/buildhome/repo/pages/profile/profile-information/education.vue")
  },
  {
    name: "profile-services-offered-availabilities",
    path: "/profile/services-offered/availabilities",
    meta: availabilitiesYBAzuxcVJbkQAelst_45jrMXnPP67b4apIF0o_ybjjQFEMeta || {},
    alias: ["/my-profile/availabilities"],
    component: () => import("/opt/buildhome/repo/pages/profile/services-offered/availabilities.vue")
  },
  {
    name: "profile-profile-information-your-profile",
    path: "/profile/profile-information/your-profile",
    meta: your_45profilesF6T659l2rqhS5kWTlnHai3W2EkuiDL5kvYwNq3_451fYMeta || {},
    alias: ["/my-profile/profile-info/your-profile"],
    component: () => import("/opt/buildhome/repo/pages/profile/profile-information/your-profile.vue")
  },
  {
    name: "profile-services-offered-indicative-rates",
    path: "/profile/services-offered/indicative-rates",
    meta: indicative_45ratesAfJkrBkK9bEH5XXUuC2uuhEe8prSzztuRpqhlXs2EOYMeta || {},
    alias: ["/my-profile/services/rates"],
    component: () => import("/opt/buildhome/repo/pages/profile/services-offered/indicative-rates.vue")
  },
  {
    name: "profile-services-offered-service-offerings",
    path: "/profile/services-offered/service-offerings",
    meta: service_45offeringszfYKwK55RsqTuCLAN_45QLprqsLDMz5tYdLel7eAdZYTEMeta || {},
    alias: ["/my-profile/services/service-offerings"],
    component: () => import("/opt/buildhome/repo/pages/profile/services-offered/service-offerings.vue")
  },
  {
    name: "profile-profile-information-work-experience",
    path: "/profile/profile-information/work-experience",
    meta: work_45experienceXB5CQsfuI4LSP4ORuACsjU629V_450nNq7X1jyZj369v4Meta || {},
    alias: ["/my-profile/work-experience"],
    component: () => import("/opt/buildhome/repo/pages/profile/profile-information/work-experience.vue")
  },
  {
    name: "profile-profile-information-personal-details",
    path: "/profile/profile-information/personal-details",
    meta: personal_45detailsV88gwBeE8UVD1bLu4EySJHTIWr5iLuGkq3CYHIBDdJ0Meta || {},
    alias: ["/my-profile/profile-info/personal-details"],
    component: () => import("/opt/buildhome/repo/pages/profile/profile-information/personal-details.vue")
  },
  {
    name: "profile-profile-information-identity-documents",
    path: "/profile/profile-information/identity-documents",
    meta: identity_45documents6N_45SSTOeRJoOxUTybPu3cVoYsTttqWPZMmwhJbi9HS0Meta || {},
    alias: ["/my-profile/profile-info/identity-documents"],
    component: () => import("/opt/buildhome/repo/pages/profile/profile-information/identity-documents.vue")
  },
  {
    name: "profile-support-requirements-required-work-hours",
    path: "/profile/support-requirements/required-work-hours",
    meta: required_45work_45hours411nD705EqlWrBeJrrjtJBnyJHIAyhGUV5o7v0ClIRwMeta || {},
    alias: ["/my-profile/support-reqs/required-work-hours"],
    component: () => import("/opt/buildhome/repo/pages/profile/support-requirements/required-work-hours.vue")
  },
  {
    name: "profile-support-requirements-support-preferences",
    path: "/profile/support-requirements/support-preferences",
    meta: support_45preferences7Noz_45w6SkG3rHgcoL6bjcmjvUdQbbA7Pdl86F6WtD74Meta || {},
    alias: ["/my-profile/travel-preferences"],
    component: () => import("/opt/buildhome/repo/pages/profile/support-requirements/support-preferences.vue")
  },
  {
    name: "profile-support-requirements-support-requirements",
    path: "/profile/support-requirements/support-requirements",
    meta: support_45requirements010p5NhGSChE_45mDWVQQGsVXmXu6FNoKrsGM7wQ8C46IMeta || {},
    alias: ["/my-profile/support-reqs/support-requirements"],
    component: () => import("/opt/buildhome/repo/pages/profile/support-requirements/support-requirements.vue")
  },
  {
    name: "profile-support-requirements-qualifications-needed",
    path: "/profile/support-requirements/qualifications-needed",
    meta: qualifications_45neededaBokFuc2JcX3F4T2HA_mJEeMdU_Uq8Fbv1db91tsU8YMeta || {},
    alias: ["/my-profile/support-reqs/qualifications-needed"],
    component: () => import("/opt/buildhome/repo/pages/profile/support-requirements/qualifications-needed.vue")
  },
  {
    name: "profile-services-offered-support-seeker-preferences",
    path: "/profile/services-offered/support-seeker-preferences",
    meta: support_45seeker_45preferences2w4557DLqZVloyThRw887m_pbbu_45oCUOjavASWi00YUMeta || {},
    alias: ["/my-profile/services/preferences"],
    component: () => import("/opt/buildhome/repo/pages/profile/services-offered/support-seeker-preferences.vue")
  },
  {
    name: "profile-profile-information-required-documents",
    path: "/profile/profile-information/required-documents",
    meta: index2nw18EFlRdPnU8HTzR1CvBILvjWJ_45wAXBmLkyiboFY4Meta || {},
    alias: ["/my-profile/profile-info/required-documents"],
    component: () => import("/opt/buildhome/repo/pages/profile/profile-information/required-documents/index.vue")
  },
  {
    name: "profile-profile-information-training-and-qualifications",
    path: "/profile/profile-information/training-and-qualifications",
    meta: training_45and_45qualifications_45LJPSXEcZXkLYsM_b7WCtKxqsUs2xvSZUpwSH374RAAMeta || {},
    alias: ["/my-profile/training-qualifications"],
    component: () => import("/opt/buildhome/repo/pages/profile/profile-information/training-and-qualifications.vue")
  },
  {
    name: "profile-profile-information-required-documents-document",
    path: "/profile/profile-information/required-documents/:document()",
    meta: _91document_93NKft53uX0nKUZnJKM3ZAcvE_45evXbn7DVyTpai8ox8aYMeta || {},
    alias: ["/my-profile/profile-info/required-documents/:document()"],
    component: () => import("/opt/buildhome/repo/pages/profile/profile-information/required-documents/[document].vue")
  }
]